// extracted by mini-css-extract-plugin
module.exports = {"note-content-text-wrap":"note-content-text-wrap--3VRozyCD","ie-note-content-text-wrap":"ie-note-content-text-wrap--1FJTioce"};